import "core-js/modules/es6.promise";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import { UnavailabilityError } from '@unimodules/core';
import mapValues from 'lodash/mapValues';
import React from 'react';
import findNodeHandle from "react-native-web/dist/exports/findNodeHandle";
import Platform from "react-native-web/dist/exports/Platform";
import ViewPropTypes from "react-native-web/dist/exports/ViewPropTypes";
import { PermissionStatus } from "./Camera.types";
import ExponentCamera from "./ExponentCamera";
import _CameraManager from "./ExponentCameraManager";
var CameraManager = _CameraManager;
var EventThrottleMs = 500;
var _PICTURE_SAVED_CALLBACKS = {};
var _GLOBAL_PICTURE_ID = 1;

function ensurePictureOptions(options) {
  var pictureOptions = options || {};

  if (!pictureOptions || typeof pictureOptions !== 'object') {
    pictureOptions = {};
  }

  if (!pictureOptions.quality) {
    pictureOptions.quality = 1;
  }

  if (pictureOptions.onPictureSaved) {
    var id = _GLOBAL_PICTURE_ID++;
    _PICTURE_SAVED_CALLBACKS[id] = pictureOptions.onPictureSaved;
    pictureOptions.id = id;
    pictureOptions.fastMode = true;
  }

  return pictureOptions;
}

function ensureRecordingOptions(options) {
  var recordingOptions = options || {};

  if (!recordingOptions || typeof recordingOptions !== 'object') {
    recordingOptions = {};
  } else if (typeof recordingOptions.quality === 'string') {
    recordingOptions.quality = Camera.Constants.VideoQuality[recordingOptions.quality];
  }

  return recordingOptions;
}

function ensureNativeProps(options) {
  var props = options || {};

  if (!props || typeof props !== 'object') {
    props = {};
  }

  var newProps = mapValues(props, convertProp);
  var propsKeys = Object.keys(newProps);

  if (!propsKeys.includes('barCodeScannerSettings') && propsKeys.includes('barCodeTypes')) {
    console.warn("The \"barCodeTypes\" prop for Camera is deprecated and will be removed in SDK 34. Use \"barCodeScannerSettings\" instead.");
    newProps.barCodeScannerSettings = {
      barCodeTypes: newProps.barCodeTypes
    };
  }

  if (props.onBarCodeScanned) {
    newProps.barCodeScannerEnabled = true;
  }

  if (props.onFacesDetected) {
    newProps.faceDetectorEnabled = true;
  }

  if (Platform.OS !== 'android') {
    delete newProps.ratio;
    delete newProps.useCamera2Api;
  }

  return newProps;
}

function convertProp(value, key) {
  if (typeof value === 'string' && Camera.ConversionTables[key]) {
    return Camera.ConversionTables[key][value];
  }

  return value;
}

function _onPictureSaved(_ref) {
  var nativeEvent = _ref.nativeEvent;
  var id = nativeEvent.id,
      data = nativeEvent.data;
  var callback = _PICTURE_SAVED_CALLBACKS[id];

  if (callback) {
    callback(data);
    delete _PICTURE_SAVED_CALLBACKS[id];
  }
}

var Camera = function (_React$Component) {
  _inherits(Camera, _React$Component);

  var _super = _createSuper(Camera);

  function Camera() {
    var _this;

    _classCallCheck(this, Camera);

    _this = _super.apply(this, arguments);
    _this._lastEvents = {};
    _this._lastEventsTimes = {};

    _this._onCameraReady = function () {
      if (_this.props.onCameraReady) {
        _this.props.onCameraReady();
      }
    };

    _this._onMountError = function (_ref2) {
      var nativeEvent = _ref2.nativeEvent;

      if (_this.props.onMountError) {
        _this.props.onMountError(nativeEvent);
      }
    };

    _this._onObjectDetected = function (callback) {
      return function (_ref3) {
        var nativeEvent = _ref3.nativeEvent;
        var type = nativeEvent.type;

        if (_this._lastEvents[type] && _this._lastEventsTimes[type] && JSON.stringify(nativeEvent) === _this._lastEvents[type] && new Date().getTime() - _this._lastEventsTimes[type].getTime() < EventThrottleMs) {
          return;
        }

        if (callback) {
          callback(nativeEvent);
          _this._lastEventsTimes[type] = new Date();
          _this._lastEvents[type] = JSON.stringify(nativeEvent);
        }
      };
    };

    _this._setReference = function (ref) {
      if (ref) {
        _this._cameraRef = ref;

        if (Platform.OS === 'web') {
          _this._cameraHandle = ref;
        } else {
          _this._cameraHandle = findNodeHandle(ref);
        }
      } else {
        _this._cameraRef = null;
        _this._cameraHandle = null;
      }
    };

    return _this;
  }

  _createClass(Camera, [{
    key: "takePictureAsync",
    value: function takePictureAsync(options) {
      var pictureOptions;
      return _regeneratorRuntime.async(function takePictureAsync$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              pictureOptions = ensurePictureOptions(options);
              _context.next = 3;
              return _regeneratorRuntime.awrap(CameraManager.takePicture(pictureOptions, this._cameraHandle));

            case 3:
              return _context.abrupt("return", _context.sent);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, null, this, null, Promise);
    }
  }, {
    key: "getSupportedRatiosAsync",
    value: function getSupportedRatiosAsync() {
      return _regeneratorRuntime.async(function getSupportedRatiosAsync$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (CameraManager.getSupportedRatios) {
                _context2.next = 2;
                break;
              }

              throw new UnavailabilityError('Camera', 'getSupportedRatiosAsync');

            case 2:
              _context2.next = 4;
              return _regeneratorRuntime.awrap(CameraManager.getSupportedRatios(this._cameraHandle));

            case 4:
              return _context2.abrupt("return", _context2.sent);

            case 5:
            case "end":
              return _context2.stop();
          }
        }
      }, null, this, null, Promise);
    }
  }, {
    key: "getAvailablePictureSizesAsync",
    value: function getAvailablePictureSizesAsync(ratio) {
      return _regeneratorRuntime.async(function getAvailablePictureSizesAsync$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (CameraManager.getAvailablePictureSizes) {
                _context3.next = 2;
                break;
              }

              throw new UnavailabilityError('Camera', 'getAvailablePictureSizesAsync');

            case 2:
              _context3.next = 4;
              return _regeneratorRuntime.awrap(CameraManager.getAvailablePictureSizes(ratio, this._cameraHandle));

            case 4:
              return _context3.abrupt("return", _context3.sent);

            case 5:
            case "end":
              return _context3.stop();
          }
        }
      }, null, this, null, Promise);
    }
  }, {
    key: "recordAsync",
    value: function recordAsync(options) {
      var recordingOptions;
      return _regeneratorRuntime.async(function recordAsync$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (CameraManager.record) {
                _context4.next = 2;
                break;
              }

              throw new UnavailabilityError('Camera', 'recordAsync');

            case 2:
              recordingOptions = ensureRecordingOptions(options);
              _context4.next = 5;
              return _regeneratorRuntime.awrap(CameraManager.record(recordingOptions, this._cameraHandle));

            case 5:
              return _context4.abrupt("return", _context4.sent);

            case 6:
            case "end":
              return _context4.stop();
          }
        }
      }, null, this, null, Promise);
    }
  }, {
    key: "stopRecording",
    value: function stopRecording() {
      if (!CameraManager.stopRecording) {
        throw new UnavailabilityError('Camera', 'stopRecording');
      }

      CameraManager.stopRecording(this._cameraHandle);
    }
  }, {
    key: "pausePreview",
    value: function pausePreview() {
      if (!CameraManager.pausePreview) {
        throw new UnavailabilityError('Camera', 'pausePreview');
      }

      CameraManager.pausePreview(this._cameraHandle);
    }
  }, {
    key: "resumePreview",
    value: function resumePreview() {
      if (!CameraManager.resumePreview) {
        throw new UnavailabilityError('Camera', 'resumePreview');
      }

      CameraManager.resumePreview(this._cameraHandle);
    }
  }, {
    key: "render",
    value: function render() {
      var nativeProps = ensureNativeProps(this.props);

      var onBarCodeScanned = this._onObjectDetected(this.props.onBarCodeScanned);

      var onFacesDetected = this._onObjectDetected(this.props.onFacesDetected);

      return React.createElement(ExponentCamera, _extends({}, nativeProps, {
        ref: this._setReference,
        onCameraReady: this._onCameraReady,
        onMountError: this._onMountError,
        onBarCodeScanned: onBarCodeScanned,
        onFacesDetected: onFacesDetected,
        onPictureSaved: _onPictureSaved
      }));
    }
  }], [{
    key: "isAvailableAsync",
    value: function isAvailableAsync() {
      return _regeneratorRuntime.async(function isAvailableAsync$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (CameraManager.isAvailableAsync) {
                _context5.next = 2;
                break;
              }

              throw new UnavailabilityError('expo-camera', 'isAvailableAsync');

            case 2:
              _context5.next = 4;
              return _regeneratorRuntime.awrap(CameraManager.isAvailableAsync());

            case 4:
              return _context5.abrupt("return", _context5.sent);

            case 5:
            case "end":
              return _context5.stop();
          }
        }
      }, null, null, null, Promise);
    }
  }, {
    key: "getAvailableCameraTypesAsync",
    value: function getAvailableCameraTypesAsync() {
      return _regeneratorRuntime.async(function getAvailableCameraTypesAsync$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (CameraManager.getAvailableCameraTypesAsync) {
                _context6.next = 2;
                break;
              }

              throw new UnavailabilityError('expo-camera', 'getAvailableCameraTypesAsync');

            case 2:
              _context6.next = 4;
              return _regeneratorRuntime.awrap(CameraManager.getAvailableCameraTypesAsync());

            case 4:
              return _context6.abrupt("return", _context6.sent);

            case 5:
            case "end":
              return _context6.stop();
          }
        }
      }, null, null, null, Promise);
    }
  }, {
    key: "getPermissionsAsync",
    value: function getPermissionsAsync() {
      return _regeneratorRuntime.async(function getPermissionsAsync$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", CameraManager.getPermissionsAsync());

            case 1:
            case "end":
              return _context7.stop();
          }
        }
      }, null, null, null, Promise);
    }
  }, {
    key: "requestPermissionsAsync",
    value: function requestPermissionsAsync() {
      return _regeneratorRuntime.async(function requestPermissionsAsync$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt("return", CameraManager.requestPermissionsAsync());

            case 1:
            case "end":
              return _context8.stop();
          }
        }
      }, null, null, null, Promise);
    }
  }]);

  return Camera;
}(React.Component);

export { Camera as default };
Camera.Constants = {
  Type: CameraManager.Type,
  FlashMode: CameraManager.FlashMode,
  AutoFocus: CameraManager.AutoFocus,
  WhiteBalance: CameraManager.WhiteBalance,
  VideoQuality: CameraManager.VideoQuality,
  VideoStabilization: CameraManager.VideoStabilization || {}
};
Camera.ConversionTables = {
  type: CameraManager.Type,
  flashMode: CameraManager.FlashMode,
  autoFocus: CameraManager.AutoFocus,
  whiteBalance: CameraManager.WhiteBalance
};
Camera.defaultProps = {
  zoom: 0,
  ratio: '4:3',
  focusDepth: 0,
  faceDetectorSettings: {},
  type: CameraManager.Type.back,
  autoFocus: CameraManager.AutoFocus.on,
  flashMode: CameraManager.FlashMode.off,
  whiteBalance: CameraManager.WhiteBalance.auto
};
var Constants = Camera.Constants,
    getPermissionsAsync = Camera.getPermissionsAsync,
    requestPermissionsAsync = Camera.requestPermissionsAsync;
export { Constants, getPermissionsAsync, requestPermissionsAsync };
export { PermissionStatus };